import { useEffect, useState } from "react";

export const COMPACT_VIEWPORT_QUERY = "(max-width: 1023px)";
export const PHONE_VIEWPORT_QUERY = "(max-width: 767px)";

function mediaQueryMatches(query: string): boolean {
  if (typeof window === "undefined") return false;
  if (typeof window.matchMedia !== "function") return true;
  return window.matchMedia(query).matches;
}

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => mediaQueryMatches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const result = window.matchMedia(query);
    const update = () => setMatches(result.matches);
    update();
    result.addEventListener("change", update);
    return () => result.removeEventListener("change", update);
  }, [query]);

  return matches;
}
